export default {
  common: {
    customize: "Personalizado",
    day: "Hoy",
    thisMonth: "Este mes",
    thisWeek: "Esta semana",
    thisYear: "Este año",
    thisQuarter: "Este trimestre",
    today: "Hoy",
    week: "Semana",
    month: "Mes",
    quarter: "Trimestre",
    year: "Año",
    all: "Todo",
    cancel: "Cancelar",
    save: "Guardar",
    delete: "Eliminar",
    edit: "Editar",
    search: "Buscar...",
    noResults: "No se encontraron resultados",
    yes: "Sí",
    no: "No",
    confirm: "Confirmar",
    close: "Cerrar",
    loading: "Cargando...",
    error: "Error",
    retry: "Reintentar",
    success: "Éxito",
    completed: "Completado",
    inProgress: "En progreso",
    todayAt: "Hoy a las {{time}}",
    yesterdayAt: "Ayer a las {{time}}",
    tomorrowAt: "Mañana a las {{time}}",
    copy: "Copiar",
    copied: "¡Copiado!",
    expand: "Expandir",
    shrink: "Contraer",
    tooManyChanges: "Demasiados cambios"
  },
  welcome: "Bienvenido a {{appName}}",
  nav: {
    home: "Inicio",
    about: "Acerca de",
    contact: "Contacto"
  },
  buttons: {
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar"
  },
  auth: {
    codeSentTo: "Código enviado a ",
    appName: "PlanifAI",
    tagline: "Domina el presente, construye tu futuro",
    validationCode: "Código de validación",
    validate: "Validar",
    backToLogin: "Volver al inicio de sesión",
    enterValidationCode: "Por favor, ingrese el código de verificación que enviamos a su correo electrónico.",
    validateAccount: "Validar Cuenta",
    resendCode: "Reenviar Código",
    resendCodeIn: "Reenviar código en {{seconds}}s"
  },
  login: {
    title: "Iniciar Sesión",
    email: "Correo electrónico",
    password: "Contraseña",
    submit: "Iniciar Sesión",
    loading: "Iniciando sesión...",
    error: "Error de inicio de sesión",
    genericError: "Error al iniciar sesión",
    orContinueWith: "O continuar con",
    noAccount: "¿No tienes una cuenta?",
    signUp: "Regístrate",
    providers: {
      google: "Google",
      apple: "Apple"
    },
    validateAccount: "Validar Cuenta",
    enterValidationCode: "Por favor, ingresa el código de verificación que enviamos a tu correo.",
    validationCode: "Código de validación",
    validate: "Validar",
    backToLogin: "Volver al inicio de sesión"
  },
  register: {
    title: "Crear Cuenta",
    fullName: "Nombre completo",
    email: "Correo electrónico",
    password: "Contraseña",
    submit: "Crear Cuenta",
    loading: "Creando cuenta...",
    error: "Error de registro",
    genericError: "Registro fallido",
    haveAccount: "¿Ya tienes una cuenta?",
    signIn: "Iniciar sesión",
    accept: "Acepto los",
    terms: "Términos y Condiciones",
    acceptTermsError: "Debes aceptar los Términos y Condiciones"
  },
  forgotPassword: {
    title: "Restablecer Contraseña",
    description: "Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña",
    emailPlaceholder: "Correo electrónico",
    submit: "Enviar enlace de restablecimiento",
    loading: "Enviando enlace...",
    backToLogin: "Volver al inicio de sesión",
    success: "Si existe una cuenta asociada a este correo, recibirás un enlace para restablecer la contraseña",
    error: "Error al restablecer la contraseña",
    genericError: "No se pudo enviar el enlace de restablecimiento"
  },
  navbar: {
    title: "PlanifAI",
    darkMode: "Activar/desactivar modo oscuro",
    logout: "Cerrar sesión",
    loggingOut: "Cerrando sesión...",
    language: "Cambiar idioma"
  },
  navigation: {
    home: "Inicio",
    journal: "Diario",
    goals: "Metas",
    profile: "Perfil"
  },
  profile: {
    title: "Mi Perfil"
  },
  userDetails: {
    title: "Detalles de la Cuenta",
    name: {
      label: "Nombre",
      notSpecified: "No especificado"
    },
    email: {
      label: "Correo electrónico",
      notSpecified: "No especificado"
    },
    status: {
      verified: "Verificado",
      pending: "Pendiente de verificación",
    },
    security: {
      verified: "Tu cuenta está verificada",
      verifyEmail: "Verificar correo electrónico",
    }
  },
  userProfile: {
    title: "Información Personal",
    unsavedChanges: "Tienes cambios no guardados. ¿Deseas continuar sin guardar?",
    allChangesSaved: "Todos los cambios guardados",
    saveChanges: "Guardar cambios",
    biography: {
      label: "Biografía",
      placeholder: "Cuéntanos un poco sobre ti..."
    },
    expectations: {
      label: "¿Qué esperas lograr con Stoic?",
      placeholder: "Tus metas y expectativas..."
    },
    edit: "Editar",
    save: "Guardar",
    error: "Error al actualizar el perfil"
  },
  settings: {
    morningNotifications: "Notificaciones matutinas",
    eveningNotifications: "Notificaciones nocturnas",
    notificationPreferences: "Preferencias de notificaciones",
    title: "Ajustes",
    darkMode: "Modo oscuro",
    language: "Idioma",
    notifications: "Notificaciones",
    languages: {
      en: "Inglés",
      es: "Español",
      fr: "Francés"
    },
    edit: "Editar",
    save: "Guardar",
    cancel: "Cancelar",
    error: "Error al actualizar la configuración"
  },
  home: {
    stats: {
      streak: {
        title: "Racha Actual",
        unit: "días",
        weekTrend: "+2 esta semana"
      },
      challenges: {
        title: "Desafíos Completados",
        progress: "40% completado"
      }
    },
    moodChart: {
      title: "Estado de Ánimo Semanal",

    }
  },
  weeklyHighlights: {
    title: "Logros Semanales",
    highlights: {
      streak: {
        title: "Racha más larga",
        description: "7 días consecutivos de reflexión"
      },
      achievement: {
        title: "Logro desbloqueado",
        description: "Completó 5 desafíos estoicos"
      },
      goal: {
        title: "Meta alcanzada",
        description: "Meditación diaria durante 1 semana"
      }
    }
  },
  challenges: {
    title: "Próximos Desafíos",
    items: {
      negativeVisualization: {
        title: "Visualización Negativa",
        description: "Practica el arte de anticipar adversidades"
      },
      dailyGratitude: {
        title: "Gratitud Diaria",
        description: "Encuentra 3 cosas por las que estar agradecido"
      },
      morningMeditation: {
        title: "Meditación Matutina",
        description: "10 minutos de reflexión al despertar"
      }
    }
  },
  subscription: {
    title: "Suscripción",
    plans: {
      free: "Plan Gratuito",
      premium: "Premium"
    },
    features: {
      ai: "Acceso ilimitado al mentor de IA",
      challenges: "Desafíos premium exclusivos",
      stats: "Estadísticas avanzadas",
      reminders: "Recordatorios personalizados",
      ads: "Experiencia sin anuncios"
    },
    upgrade: "Mejora a Premium"
  },
  quickActions: {
    shortcuts: "Tip: usa Alt +1 hasta Alt +2, para acceder rápidamente a las acciones",
    dailyChallenge: "Desafío Diario",
    newGoal: "Nueva Meta",
    aiConsult: "Consultar IA",
    viewJournal: "Ver Diario"
  },
  journal: {
    title: "Mi Diario",
    edit: "Editar",
    cancelEdit: "Cancelar edición",
    saveSuccess: "Guardado exitosamente",
    updateSuccess: "Actualizado exitosamente",
    saveError: "Error al guardar la entrada",
    tabs: {
      morning: "Mañana",
      evening: "Noche"
    },
    analysis: {
      title: "Análisis y Consejos",
      observations: "Observaciones",
      tomorrowSuggestions: "Sugerencias para mañana"
    },
    metrics: {
      mood: "Estado de ánimo",
      energy: "Nivel de energía",
      motivation: "Motivación",
      accomplishment: "Logros del día",
      reflection: "Nivel de reflexión"
    },
    prompts: {
      morning: {
        gratitude: "¿Por qué estoy agradecido hoy?",
        intention: "¿Cuál es mi principal intención para el día?"
      },
      evening: {
        learnings: "¿Qué he aprendido hoy?",
        improvements: "¿Qué podría mejorar mañana?"
      }
    },
    placeholder: "Escribe tu reflexión aquí...",
    saveButton: "Guardar Reflexión",
    noEntry: "No hay entrada para esta parte del día.",
    noReflection: "Sin reflexión",
    editButton: "Editar",
    clickToExpand: "Haz clic para expandir"
  },
  goals: {
    title: "Mis Metas",
    newGoal: "Nueva Meta",
    emptyState: "Aún no has creado ninguna meta. ¡Crea tu primera meta!",
    search: "Buscar metas...",
    overview: {
      completed: "Completadas",
      goals: "Metas"
    },
    duration: {
      all: "Todas",
      short: "Corto plazo",
      medium: "Mediano plazo",
      long: "Largo plazo"
    },
    status: {
      all: "Todas",
      completed: "Completadas",
      inProgress: "En progreso"
    },
    sort: {
      newest: "Más recientes",
      oldest: "Más antiguas",
      mostProgress: "Más progreso",
      leastProgress: "Menos progreso"
    },
    stats: {
      averageProgress: "Progreso promedio",
      completedTasks: "Tareas completadas",
      inProgressGoals: "Metas en progreso"
    },
    progress: {
      label: "Progreso"
    },
    tasks: {
      label: "Tareas"
    },
    daysRemaining: {
      label: "Días restantes"
    },
    wizard: {
      success: "¡Meta creada exitosamente!",
      title: "Crear nuevo objetivo",
      submitting: "Creando tu objetivo...",
      steps: {
        duration: {
          title: "Duración",
          description: "Selecciona el horizonte temporal para tu objetivo"
        },
        dates: {
          title: "Fechas",
          description: "Define el período para lograr tu objetivo"
        },
        details: {
          title: "Detalles",
          description: "Describe tu objetivo y los pasos para lograrlo"
        }
      },
      durations: {
        short: {
          label: "Corto plazo",
          description: "Objetivos rápidos y enfocados para impulsar tu motivación"
        },
        medium: {
          label: "Mediano plazo",
          description: "Objetivos que requieren planificación y compromiso constante"
        },
        long: {
          label: "Largo plazo",
          description: "Transformaciones profundas que marcan un cambio significativo"
        }
      },
      dates: {
        startDate: "Fecha de inicio",
        endDate: "Fecha de finalización"
      },
      details: {
        titleLabel: "Título del objetivo",
        titlePlaceholder: "Ingresa un título conciso para el objetivo",
        descriptionLabel: "Descripción",
        descriptionPlaceholder: "Describe los pasos para lograr tu objetivo"
      },
      errors: {
        dates: {
          startAfterEnd: "La fecha de inicio debe ser anterior a la fecha de finalización"
        },
        details: {
          emptyTitle: "Por favor ingresa un título para tu objetivo",
          emptyDescription: "Por favor describe los detalles de tu objetivo"
        },
        submission: "Error al crear el objetivo. Por favor intenta nuevamente."
      },
      buttons: {
        previous: "Anterior",
        next: "Siguiente",
        submit: "Crear objetivo"
      }
    },
    lastUpdated: "Última actualización el "
  },
  streakStats: {
    title: "Racha Diaria",
    days: "días",
    longestStreak: "Racha más larga",
    consistencyLevel: "Nivel de consistencia",
    lastActivity: "Última actividad",
    daysAgo: "días atrás",
    viewDetails: "Ver detalles",
    detailsTitle: "Detalles de la racha",
    currentStreak: "Racha actual",
    achievements: "Logros",
    level: "Nivel",
    history: "Historial de rachas",
    period: "Período",
    duration: "Duración",
    completionByDay: "Cumplimiento por día",
    totalStats: "Estadísticas totales",
    totalTasksCompleted: "Total de tareas completadas",
    resetStreak: "Restablecer racha",
    confirmReset: "¿Estás seguro de que deseas restablecer tu racha? Esta acción no se puede deshacer.",
    noData: "No hay datos de racha disponibles",
    noHistory: "No hay historial previo de rachas",
    lastCompletedOn: "Última actividad: {{date}}",
    noCompletedTasks: "Aún no hay tareas completadas",
    levels: {
      beginner: "Principiante",
      consistent: "Consistente",
      dedicated: "Dedicado",
      master: "Maestro"
    }
  },
  stats: {
    totalGoals: "Total de metas",
    completedGoals: "Metas completadas",
    onTrackGoals: "Metas en camino",
    behindGoals: "Metas atrasadas",
    goalsLabel: "metas",
    completedLabel: "completadas",
    inProgressLabel: "en progreso",
    behindLabel: "atrasadas",
    aboveExpected: "por encima de lo esperado",
    belowExpected: "por debajo de lo esperado",
    daysRemaining: "Días restantes",
    completedTasks: "Tareas completadas",
    completedMilestones: "Hitos completados",
    overdueTasks: "Tareas atrasadas"
  },
  examples: {
    exampleGoal: "Meta de ejemplo",
    learnReactNative: "Aprender React Native",
    completeTypeScriptCourse: "Completar curso de TypeScript",
    personalProject: "Proyecto personal"
  },
  moodChart: {
    noDataYet: "Aún no has registrado tu estado de ánimo",
    noDataTitle: "No hay datos de ánimo disponibles",
    createEntry: "Crear entrada",
    emptyStates: {
      week: "Comienza a escribir en tu diario para seguir tu bienestar emocional.",
      month: "Escribir regularmente ayuda a identificar patrones emocionales.",
      all: "Registrar tu ánimo regularmente puede ayudarte a seguir tu viaje de bienestar emocional.",
    },
    title: "Seguimiento del Estado de Ánimo",
    noData: "Sin datos",
    notRecorded: "No registrado",
    average: "Promedio",
    frequentMood: "Estado de ánimo frecuente",
    trend: "Tendencia",
    records: "Registros",
    distribution: "Distribución del estado de ánimo",
    improved: "Mejorado",
    decreased: "Disminuido",
    noChange: "Sin cambios",
    toggleStats: "Mostrar/ocultar estadísticas",
    toggleDistribution: "Mostrar/ocultar distribución",
    clickForDetails: "Haz clic en los puntos para ver más detalles sobre tu estado de ánimo",
    noDataAvailable: "No hay datos disponibles para este período",
    levels: {
      veryLow: "Muy bajo",
      low: "Bajo",
      neutral: "Neutral",
      good: "Bueno",
      excellent: "Excelente"
    },
    descriptions: {
      veryLow: "Día difícil",
      low: "Por debajo de lo normal",
      neutral: "Equilibrado",
      good: "Por encima de lo normal",
      excellent: "Día excepcional"
    },
    tips: {
      veryLow: "Considera actividades que te relajen",
      low: "Pequeños logros pueden mejorar tu día",
      neutral: "Buen momento para planificar",
      good: "Aprovecha tu energía positiva",
      excellent: "Reflexiona sobre lo que funcionó hoy"
    },
    trends: {
      improving: "Mejorando",
      worsening: "Empeorando",
      stable: "Estable"
    }
  },
  calendar: {
    weekDays: {
      sunday: "Do",
      monday: "Lu",
      tuesday: "Ma",
      wednesday: "Mi",
      thursday: "Ju",
      friday: "Vi",
      saturday: "Sá"
    },
    months: {
      january: "Enero",
      february: "Febrero",
      march: "Marzo",
      april: "Abril",
      may: "Mayo",
      june: "Junio",
      july: "Julio",
      august: "Agosto",
      september: "Septiembre",
      october: "Octubre",
      november: "Noviembre",
      december: "Diciembre"
    },
    confirmButton: "Confirmar"
  }
} as const;
